module.exports = __webpack_public_path__ + "static/media/text-image.aeeb3be1.webp";